// local hook used in the context of reports page
import { useMemo } from 'react';
import { ReportDetailsQuery } from '@/__generated__/graphql';

export const useEquipmentList = (report: ReportDetailsQuery['report'] | undefined) => {
  const equipmentsListMemo = useMemo(() => {
    if (!report || !report.pointOfInterests) return [];
    const equipmentsList = report.pointOfInterests.map((poi) => poi.assembly);

    const equipmentsUniqueById = [
      ...new Map(equipmentsList.map((item) => [item.id, item])).values(),
    ];

    // If reportOrder or assemblyOrder doesn't exist, return equipmentsUniqueById directly
    if (!report?.reportOrder?.assemblyOrder || report.reportOrder?.assemblyOrder?.length === 0) {
      return equipmentsUniqueById;
    }

    // Otherwise, return ordered equipment list
    return report.reportOrder.assemblyOrder.map((id) =>
      equipmentsUniqueById.find((item) => item.id === id)
    );
  }, [report]);

  return equipmentsListMemo;
};
